export function module_reference() {
	// sideNav toggle
	$(window).on('load', function () {
		
		sideNav();
		sideNavFixed();
		
		var timer = false;
		var winWidth = $(window).width();
		var winHeight = $(window).height();
		var winWidth_resized;
		var winHeight_resized;

		$(window).on("resize", function() {
			// リサイズ後の放置時間が指定ミリ秒以下なら何もしない(リサイズ中に何度も処理が行われるのを防ぐ)
			if (timer !== false) {
				clearTimeout(timer);
			}

			// 放置時間が指定ミリ秒以上なので処理を実行
			timer = setTimeout(function() {
				// リサイズ後のウインドウの横幅を取得
				winWidth_resized = $(window).width();
				winHeight_resized = $(window).height();

				// リサイズ前のウインドウ幅とリサイズ後のウインドウ幅が異なる場合
				if ( winWidth != winWidth_resized || winHeight != winHeight_resized) {
					sideNav();
					sideNavFixed();

					// 次回以降使えるようにリサイズ後の幅をウインドウ幅に設定する
					winWidth = $(window).width();
					winHeight = $(window).height();
				}
			}, 200);
		});

		function sideNav() {
			var sideMenuList = $('.reference-list, .reference-block-group');
			var sideToggleBtn = $('.btnSpToggle,.block-grout-ttl');

			if($(window).width() < 1024 - 14) {
				$(sideMenuList).hide();
				$(sideToggleBtn).unbind('click');

				$(sideToggleBtn).on("click", function(){
					$(this).next().slideToggle();
				});
			} else {
				$(sideMenuList).show();
				$(sideToggleBtn).unbind('click');
			}
		}

		function sideNavFixed() {
			//サイドナビのクラス
			var sideNav = $('.reference-nav');

			// ---------------------------------------------------
			// PCサイズ
			// ---------------------------------------------------
			if($(window).width() > 1024 - 14) {
				//各エリアの高さを取得
				var windowH = $(window).height();
				var headerH = $('#header').outerHeight();
				var pageTitleH = $('.page-ttl').outerHeight() - 45;
				var contentH = $('.content-container').outerHeight();
				var breadcrumbH =$('.breadcrumb').outerHeight();
				var footerH = $('#footer-component').outerHeight();
				//ウィンドウサイズからヘッダー高さを引いて、サイドナビ高さに
				var sideScrollH1 = windowH - headerH - 20;
				var sideScrollH2 = windowH - pageTitleH - 20;


				// ---------------------------------------------------
				// 初回ロード時
				// ---------------------------------------------------

				//初回ロード時のサイドバー高さ
				sideNav.css({'max-height': sideScrollH2 - 80});

				//初回ロード時のバーの高さを取得
				var sideH = sideNav.outerHeight();

				//サイドバーよりコンテンツが小さいとき
				if(sideH > contentH ) {
					//コンテンツ部分にサイドバー＋ヘッダー高さを与える
					$('.content-container').css({'height': '100%','min-height': sideH + pageTitleH});
				}

				//サイドバーおよびコンテンツ部分をロードした状態で、ページ全体の高さを取得
				var pageH = $('body').height();

				//ページをフッター上部までスクロールした時の高さ
				var scrollBottom = pageH - windowH - footerH - breadcrumbH;

				//初回ロード時のスクロール位置取得
				var scrollPosition = $(this).scrollTop();

				//初回ロード時にスクロール位置がページ見出し部分の領域を超えていたら
				if(pageTitleH < scrollPosition ) {
					sideNav.addClass('fixed-side').css({'max-height': sideScrollH1, 'top':headerH});
				}

				// ---------------------------------------------------
				// スクロール時
				// ---------------------------------------------------

				$(window).scroll(function(){
					//スクロールの値を取得
					var scrollTop = $(this).scrollTop();

					//フッター領域スクロール時のサイドナビの高さを可変
					var sidaNavHMove = windowH - headerH - (scrollTop - scrollBottom) - 20;
					var sideScrollHMove = windowH - headerH - pageTitleH + scrollTop - 16;

					//スクロール位置がページ見出し部分の領域を超えたら
					if(pageTitleH < scrollTop && $(window).width() > 1100 - 18) {
						//サイドバーを固定
						sideNav.addClass('fixed-side').css({'max-height': sideScrollH1, 'top':headerH});
					}else{
						//条件から外れたらサイドバーの位置を初期値にする
						sideNav.removeClass('fixed-side').css({'max-height': sideScrollHMove, 'top': 'inherit'});
					}

					//ページの最後までスクロールされたら
					if( scrollTop > scrollBottom){
						sideNav.css({'max-height': sidaNavHMove});
					}
					else{
						//sideNav.css({'max-height': 'auto'});
					}
				});
			} else {
				// ---------------------------------------------------
				// スマホサイズ
				// ---------------------------------------------------
				sideNav.attr('style', '').removeClass('fixed-side');

				$(window).scroll(function(){
					sideNav.attr('style', '').removeClass('fixed-side');
				});
			}
		}
	});
}
